import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[libPreventReload]'
})
export class PreventReloadDirective {
  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent): void {
    event.returnValue = false;
  }
}
